// extracted by mini-css-extract-plugin
module.exports = {"review":"h8","value":"h9","name":"h-","isRental":"h_"};